module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"belt":"belte","lifeskills":"Ferdighet","journeys":"Reiser","steps":"Steg","brainDates":"Hjernedates"},"en":{"belt":"belt","lifeskills":"Lifeskills","journeys":"Journeys","steps":"Steps","brainDates":"Brain Dates"}}')
  delete Component.options._Ctor
}
